<template>
  <div>
    <v-card>
      <v-card-title style="font-weight: bold;">
        API User
        <v-btn color="#fe3d89" fab x-small class="ml" style="margin-bottom: 5px;" @click="enableFields" :disabled="!hasFullControl ">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-text-field
          label="User ID..."
          :rules="userIDRules"
          outlined
          dense
          v-model="userID"
          :disabled="fieldsEnable || disableUserID || !hasFullControl "
        ></v-text-field>

        <div class="row">
          <div class="col-sm-1" :style="serviceNowLink !== '' ? '' : 'display: none;'" >
            <a :href="serviceNowLink"  target="_blank"> 
              <svg :class="serviceNowLink !== '' ? 'serviceNowLinkDisplay' : ''"
                    :style="serviceNowLink !== '' ? '' : 'display: none;'" 
                    xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100" height="100" viewBox="0 0 72 72">
              <path d="M 43 12 C 40.791 12 39 13.791 39 16 C 39 18.209 40.791 20 43 20 L 46.34375 20 L 35.171875 31.171875 C 33.609875 32.733875 33.609875 35.266125 35.171875 36.828125 C 35.951875 37.608125 36.977 38 38 38 C 39.023 38 40.048125 37.608125 40.828125 36.828125 L 52 25.65625 L 52 29 C 52 31.209 53.791 33 56 33 C 58.209 33 60 31.209 60 29 L 60 16 C 60 13.791 58.209 12 56 12 L 43 12 z M 23 14 C 18.037 14 14 18.038 14 23 L 14 49 C 14 53.962 18.037 58 23 58 L 49 58 C 53.963 58 58 53.962 58 49 L 58 41 C 58 38.791 56.209 37 54 37 C 51.791 37 50 38.791 50 41 L 50 49 C 50 49.551 49.552 50 49 50 L 23 50 C 22.448 50 22 49.551 22 49 L 22 23 C 22 22.449 22.448 22 23 22 L 31 22 C 33.209 22 35 20.209 35 18 C 35 15.791 33.209 14 31 14 L 23 14 z"></path>
              </svg>
            </a>
          </div>
          <div :class="serviceNowLink !== '' ? 'col-sm-11' : 'col-sm-12'">
            <v-text-field
              label="Service Now profile link..."
              outlined
              dense
              v-model="serviceNowLink"
              :disabled="fieldsEnable || !hasFullControl "
            ></v-text-field>
          </div>
        </div>

        <v-textarea 
          outlined 
          label="Policies" 
          hide-details 
          dense 
          v-model="policies" 
          :disabled="fieldsEnable " 
          :readonly="!hasFullControl" 
          id="policies" 
          class="policiesText"
        ></v-textarea>
        
        <v-menu v-model="menuPolicies" top left :close-on-content-click="false">
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" class="mt-6" :disabled="fieldsEnable || !hasFullControl "><v-icon>mdi-plus</v-icon>Add Policies</v-btn>
          </template>
          <v-card style="height:600px;">
            <SetPolicies :addPolicies="addPolicies" />
          </v-card>
        </v-menu>
        <v-menu v-model="menuContryCodes" top :close-on-content-click="true">
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" class="mt-6 ml-4" :disabled="fieldsEnable || policies === '' || !hasFullControl ">Country Codes</v-btn>
          </template>
          <v-card style="height:600px;">
            <SetCountryCodes :countries="getCountries" :setCountries="setCountries" />
          </v-card>
        </v-menu>
        <v-menu v-model="menuPriceSources" top :close-on-content-click="true">
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" class="mt-6 ml-4" :disabled="fieldsEnable || policies === ''|| !hasFullControl ">Price Sources</v-btn>
          </template>
          <v-card style="height:600px;">
            <SetPriceSources :priceSources="getAllSources" :setPriceSource="setPriceSource" />
          </v-card>
        </v-menu>
      </v-card-text>      
      <v-card-actions style="padding-bottom: 26px; padding-top: 26px;">
        <v-btn small color="success" v-if="!disableUserID" style="position: absolute; right: 25px;" @click="saveUser" :disabled="fieldsEnable || (policies === '' || userID === '')|| !hasFullControl ">Save User</v-btn>
        <v-btn small color="success" v-else style="position: absolute; right: 25px;" @click="editUser" :disabled="fieldsEnable || (policies === '' || userID === '')|| !hasFullControl ">Update User</v-btn>
      </v-card-actions>
    </v-card>

    
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import countries from 'i18n-iso-countries'
  import SetCountryCodes from './SetCountryCodes'
  import SetPolicies from './SetPolicies.vue'
  import SetPriceSources from './SetPriceSources.vue'
  import { accessControlMixin } from './mixins/index'

  export default {
    props: {
      user: Object
    },
    mixins:[accessControlMixin],
    data: () => ({
      search: '',
      headers: [
        {
          text: 'Client ID',
          value: 'clientID'
        },
        {
          text: 'Name',
          value: 'name'
        },
        {
          text: 'Date of Creation',
          value: 'dateCreation'
        },
        {
          text: 'Cost',
          value: 'cost'
        },
      ],
      userIDRules: [
        v => !!v || 'User ID is required',
      ],
      serviceNowLink: '',
      itemsPriceSource: ['Generate Price Source 1', 'Generate Price Source 2', 'Generate Price Source 3'],
      userID: '',
      priceSources: [],
      fieldsDisallowed: '',
      selectedMeetingTypes: [],
      fieldsEnable: true,
      disableUserID: false,
      generatedPriceSource: '',
      priceManagerClientID: '',
      raceCardSource: '',
      noPrices: false,
      priceDelays: [
        {
          text: 'Live',
          value: '0'
        },
        {
          text: '5s delay',
          value: '5'
        },
        {
          text: '10s delay',
          value: '10'
        }
      ],
      priceDelaySelected: '',
      policies: '',
      menuContryCodes: false,
      menuPolicies: false,
      menuPriceSources: false
    }),
    components: {
      // MeetingTypes,
      // vMultiselectListbox,
      SetCountryCodes,
      SetPolicies,
      SetPriceSources
    },
    watch: {
      user () {
        if(this.user !== {}) {
          this.fieldsEnable = false
          this.disableUserID = true
        }
        // this.selectedCountries = this.user.filter.countries
        this.userID = this.user.userId
        this.serviceNowLink = this.user.serviceNowLink        
        this.policies = this.user.policies.join('\n')
      }
    },
    computed: {
      ...mapGetters(['getSources','getUserLoggedIn']),
      getCountries () {
        countries.registerLocale(require('i18n-iso-countries/langs/en.json'))
        const allCountries = countries.getNames('en')
        const countryList = []
        for (const alpha2Code in allCountries) {
          countryList.push({
            text: allCountries[alpha2Code],
            value: countries.alpha2ToAlpha3(alpha2Code)
          })
        }
        return countryList
      },
      getPriceSources () {
        const priceSources = this.getSources?.filter(source =>  source.isPriceSource === true )
        priceSources.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
        return priceSources
      },
      getAllSources () {
        const allSources = this.getSources?.slice().sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
        return allSources
      },
      hasFullControl(){
        return this.getUserLoggedIn?.roles.includes('*') || this.userHasResourceAccess(this.RESOURCENAMES.API, this.ROLEACTIONCODE.FULL) || this.userHasResourceAccess(this.RESOURCENAMES.MANAGEMENT)
      },
    },
    methods: {
      ...mapActions(['createUser', 'updateUser', 'getUsers']),
      async saveUser () {
        if(this.noPrices) {
          this.priceSources = ['zzz']
        }
        this.policies = this.policies.replace(/^\s*[\r\n]/gm, '')
        await this.createUser({ userID: this.userID, policies: this.policies, serviceNowLink: this.serviceNowLink})
        this.userID = ' '
        this.policies = ''
        this.serviceNowLink = ''
        await this.getUsers()
      },
      onMeetingTypesClick (meetingTypes) {
        this.selectedMeetingTypes = meetingTypes
      },
      enableFields () {
        this.fieldsEnable = false
        this.userID = ''
        this.policies = ''
        this.serviceNowLink = ''
        this.disableUserID = false
      },
      editUser () {
        if(this.noPrices) {
          this.priceSources = ['zzz']
        }
        this.updateUser({ userID: this.userID, policies: this.policies, serviceNowLink: this.serviceNowLink })
        this.userID = ''
        this.policies = ''
        this.serviceNowLink = ''
      },
      setCountries (countryCode) {
        const curPos = document.getElementById('policies').selectionStart
        this.policies = this.policies.slice(0, curPos) + countryCode + this.policies.slice(curPos)
      },
      addPolicies (policy) {
        if (this.policies === '') {
          this.policies = policy
        } else {
          this.policies = this.policies + '\n' + policy
        }
      },
      setPriceSource (priceSource) {
        const curPos = document.getElementById('policies').selectionStart
        this.policies = this.policies.slice(0, curPos) + priceSource + this.policies.slice(curPos)
      }
    }
  }
</script>

<style>

  .serviceNowLinkDisplay {
    fill:#fe3d89;
    width: 3rem;
    height: 3rem;
    margin-top: -5px;
  }
  .serviceNowLinkDisplay:hover {
    fill: rgb(66, 80, 88);
  }
  .mt {
    margin-top: 12px !important;
  }

  .mt2 {
    margin-top: 24px !important;
  }

  .msl-searchable-list__items {
    width: 500px !important;
  }

  .policiesText .v-input__slot {
    height: 880px;
  }

  @media (max-height: 1264px) {
    .policiesText .v-input__slot {
      height: 510px;
    }
  }
</style>
